const parisDay = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Europe/Paris",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

/**
 * Today's date in France ("YYYY-MM-DD"). `toISOString()` gives the UTC date, which is still
 * yesterday between midnight and 1–2 a.m. in Paris: never use it for a business date.
 */
export function parisToday(now = new Date()): string {
  return parisDay.format(now);
}

/** Calendar arithmetic on an ISO date, time-zone free. */
export function addDaysIso(iso: string, days: number): string {
  const [y, m, d] = iso.split("-").map(Number) as [number, number, number];
  return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10);
}

/**
 * A calendar day as "AAAA-MM-JJ", whatever the API client handed over: Eden Treaty turns every
 * such string of a response into a Date (UTC midnight), which a date input cannot show.
 */
export function isoDay(value: string | Date | null | undefined): string {
  if (!value) return "";
  return value instanceof Date ? value.toISOString().slice(0, 10) : value.slice(0, 10);
}
